/* eslint-disable */
import { isNumeric } from './my_utils.js'
class Validator {

  validateEmail(field) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(field.value);
  }

  validateExists(field) {
    return ((field.value + '').trim().length > 0) && (field.value != null)
  }

  validateMin(field) {
    return field.value >= field.min
  }

  validateMax(field) {
    return field.value <= field.max
  }

  validatePositive(field) {
    return Number(field.value) > 0;
  }

  validateNumber(field) {
    if(field.value == undefined){
      return true
    }
    return isNumeric(field.value)
  }

  validateMultipleEmails (field) {
    if(field.value == undefined){
      return true
    }
    let emails = field.value.split(',')
    let invalidated_emails = []
    for (let i = 0; i < emails.length; i++) {
      let email = emails[i]
      if (!this.validateEmail({ value: email.trim() })) {
        invalidated_emails.push(email)
      }
    }
    if (invalidated_emails.length <= 0) {
      return true
    }
    alert('האימליים הבאים לא תקינים:\n ' + invalidated_emails.join(','))
    return false
  }

  validateMultiplePhoneNumbers (field) {
    if (!field.value || field.value.trim().length === 0) {
      return true // Empty is valid
    }
    
    // Remove spaces and normalize
    const normalizedValue = field.value.replace(/\s+/g, '')
    const phones = normalizedValue.split(',').filter(phone => phone.length > 0)
    const invalidPhones = []
    
    // Israeli phone number regex: starts with 05, followed by 8 digits (total 10 digits)
    const israeliPhoneRegex = /^05\d{8}$/
    
    phones.forEach(phone => {
      if (!israeliPhoneRegex.test(phone.trim())) {
        invalidPhones.push(phone)
      }
    })
    
    if (invalidPhones.length > 0) {
      alert('מספרי הטלפון הבאים לא תקינים:\n' + invalidPhones.join(','))
      return false
    }
    
    return true
  }

  normalizePhoneNumbers (value) {
    if (!value || value.trim().length === 0) {
      return ''
    }
    
    // Remove all spaces and return normalized value
    return value.replace(/\s+/g, '')
  }

}

export default Validator;
